<template>
	<div class="row contentblock" data-aos="fade-in" data-aos-duration="1500" data-aos-once="true">
		<div class="columns column6">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column6">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-flow: row nowrap;
	align-items: stretch;
	justify-content: center;
	gap: 30px;
	padding: 0;

	.columns {
		background: var(--primary-background-color);
		margin: 0 0 50px;
	}

	.columns:first-child {
		padding: 0;
		margin: 50px 0 0;
		background: none;
	}

	&:nth-child(odd) {
		flex-direction: row-reverse;

		.columns {
			margin: 50px 0 0;
		}

		.columns:first-child {
			margin: 0 0 50px;
		}
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.contentblock-content {
		padding: 40px 50px;
		background: var(--secondary-background-color);
	}
}

@media (max-width: 1080px) {
	.contentblock {
		flex-flow: column wrap;
		max-width: 820px;
		margin: 0 auto 50px;

		.column6 {
			width: 100%;
			padding: 0 20px !important;
			margin: 0 0 10px !important;
		}
	}
}
</style>
